import { type MaybeRefOrGetter, computed, toValue, ref, watch } from "vue";
import { type Domain } from "@/composables/domain-manager";
import { type Product } from "@/composables/product-manager";
import { type Process } from "@/composables/process-manager";

export const useEntityNameManager = (
    entity: MaybeRefOrGetter<Domain | Product | Process | undefined>
) => {
    const originalName = ref<string>();

    const isModified = computed(() => {
        if (!toValue(entity)) {
            return false;
        }
        return toValue(entity)?.name !== originalName.value;
    });

    watch(
        () => toValue(entity)?.identity,
        () => {
            originalName.value = toValue(entity)?.name;
        },
        { immediate: true }
    );

    const persist = () => {
        originalName.value = toValue(entity)?.name;
    };

    const reset = () => {
        if (!toValue(entity) || !originalName.value) {
            return;
        }
        toValue(entity)!.name = originalName.value;
    };

    return { isModified, originalName, reset, persist };
};
